import React from 'react'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'
import { LDProps } from 'launchdarkly-react-client-sdk/lib/withLDConsumer'
import { Flag } from '@api'
import css from './sisense.module.scss'

function Sisense(props: LDProps) {
  if (!props.flags?.[Flag.SISENSE]) {
    return <div>Not Found</div>
  }

  let domain
  try {
    domain = window.location.host.match(/.+?(\w+\.\w{3})$/)?.[1] || 'spaceiq.dev'
  } catch (err) {
    domain = 'spaceiq.dev'
  }
  return (
    <iframe
      title="Sisense"
      className={css.si_frame}
      src={`${window.location.protocol}//sisense.${domain}/app/main#/home`}
    />
  )
}

export default withLDConsumer()(Sisense)
